import { useDispatch, useSelector } from "react-redux";
import { State } from "redux/store";
import {
  setShowCart,
  setTempExportData,
  clearExportData,
  setLastSelectedIndex,
} from "redux/SingleDataset/actions";
import XIcon from "assets/icons/XIcon";

import styles from "./style.module.scss";

const ToolTipBox = ({ removeAll, setRemoveAll }: any) => {
  const dispatch = useDispatch();

  //used for cart actions since it is not accessible from useParams there
  const datasetID = useSelector(
    (state: State) => state.singleDataset?.stats?.dataset?.id
  );

  const cancelRemoveAll = () => {
    setRemoveAll(false);
  };
  const confirmRemoveAll = () => {
    dispatch(clearExportData(datasetID) as any);
    setRemoveAll(false);
    dispatch(setShowCart(false));
    dispatch(setLastSelectedIndex(null));
  };

  const handleCrossClick = () => {
    if (removeAll) {
      setRemoveAll(false);
    } else {
      dispatch(setTempExportData(null));
    }
  };

  return (
    <div
      className={styles.tooltipBox}
      onClick={(e: any) => e.stopPropagation()}
    >
      <div className={styles.tooltipTitleContainer}>
        <div className={styles.tooltipTitle}>Clear All</div>
        <div className={styles.crossIcon} onClick={handleCrossClick}>
          <XIcon variant="new" />
        </div>
      </div>
      <div className={styles.tooltipMessage}>
        This will clear all of the items selected in this Dataset
      </div>

      <div className={styles.tooltipButtons}>
        <div className={styles.cancelTooltipButton} onClick={cancelRemoveAll}>
          Cancel
        </div>
        <div className={styles.clearTooltipButton} onClick={confirmRemoveAll}>
          Clear All
        </div>
      </div>
    </div>
  );
};

export default ToolTipBox;
